var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJediHrSolutions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "90 225 905 630",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: #fede8c;\n      }\n\n      .cls-5 {\n        fill: #012748;\n        font-family: CenturyGothic-Bold, 'Century Gothic';\n        font-size: 115px;\n        font-weight: 700;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 540,
    y1: 488.71,
    x2: 540,
    y2: 448.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#012748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f4e6f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 543.22,
    y1: 387.3,
    x2: 543.22,
    y2: 427.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fe9816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#f69318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e1871f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#bf7229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#b66d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 543.22,
    y1: 328.74,
    x2: 543.22,
    y2: 368.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fe9816"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 540,
    y1: 769.94,
    x2: 540,
    y2: 809.82,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M943.89,488.71H136.11l6.38-24.12c2.42-9.16,13.27-15.77,25.89-15.77h743.25c12.62,0,23.46,6.61,25.89,15.77l6.38,24.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M851.07,427.18H235.36l4.57-22.65c2.02-10.01,11.06-17.23,21.56-17.23h563.44c10.51,0,19.54,7.22,21.56,17.23l4.57,22.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M794.59,368.62h-502.74l3.73-22.65c1.65-10.01,9.03-17.23,17.61-17.23h460.07c8.58,0,15.96,7.22,17.61,17.23l3.73,22.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M704.17,310.06h-328.34l2.44-22.65c1.08-10.01,5.9-17.23,11.5-17.23h300.47c5.6,0,10.42,7.22,11.5,17.23l2.44,22.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M943.89,809.82H136.11l6.38-24.12c2.42-9.16,13.27-15.77,25.89-15.77h743.25c12.62,0,23.46,6.61,25.89,15.77l6.38,24.12Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(426.15 599.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "JEDI"), /*#__PURE__*/React.createElement("tspan", {
    x: -275.96,
    y: 138
  }, "HR SOLUTIONS")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJediHrSolutions);
export default __webpack_public_path__ + "static/media/jedi-hr-solutions.91478e589b0f825ffffeb3354b81a1a6.svg";
export { ForwardRef as ReactComponent };